<template>
	<div v-if="card.length>0" class="row">
		<div class="col-md-6 col-xl-3">
			<inertia-link
				class="block block-rounded block-link-shadow"
				:href="route('admin.monitoring.index', { tab: 'Silver' })"
			>
				<div class="block-content text-end">
					<div class="fs-2 fw-bold">{{ card[0].total }}</div>
					<div class="fs-sm fw-semibold text-uppercase text-muted">Silver</div>
					<div class="fs-sm fw-semibold text-uppercase text-muted">
						Total Entries
					</div>
				</div>
				<div
					class="block-content block-content-full d-flex justify-content-between align-items-center text-center"
				>
					<div class="fs-xs text-muted text-uppercase">
						<h6 class="mb-0 fw-semibold">{{ card[0].new }}</h6>
						<span>New</span>
					</div>
					<div class="fs-xs text-muted text-uppercase">
						<h6 class="mb-0 fw-semibold">{{ card[0].upgrade }}</h6>
						<span>Upgrade</span>
					</div>
					<div class="fs-xs text-muted text-uppercase">
						<h6 class="mb-0 fw-semibold">{{ card[0].renew }}</h6>
						<span>Renew</span>
					</div>
				</div>
			</inertia-link>
		</div>
		<div class="col-md-6 col-xl-3">
			<inertia-link
				class="block block-rounded block-link-shadow"
				:href="route('admin.monitoring.index', { tab: 'Gold' })"
			>
				<div class="block-content text-end">
					<div class="fs-2 fw-bold">{{ card[0].total }}</div>
					<div class="fs-sm fw-semibold text-uppercase text-muted">Gold</div>
					<div class="fs-sm fw-semibold text-uppercase text-muted">
						Total Entries
					</div>
				</div>
				<div
					class="block-content block-content-full d-flex justify-content-between align-items-center text-center"
				>
					<div class="fs-xs text-muted text-uppercase">
						<h6 class="mb-0 fw-semibold">{{ card[0].new }}</h6>
						<span>New</span>
					</div>
					<div class="fs-xs text-muted text-uppercase">
						<h6 class="mb-0 fw-semibold">{{ card[0].upgrade }}</h6>
						<span>Upgrade</span>
					</div>
					<div class="fs-xs text-muted text-uppercase">
						<h6 class="mb-0 fw-semibold">{{ card[0].renew }}</h6>
						<span>Renewals</span>
					</div>
				</div>
			</inertia-link>
		</div>
		<div class="col-md-6 col-xl-3">
			<inertia-link
				class="block block-rounded block-link-shadow"
				:href="route('admin.monitoring.index', { tab: 'Diamond' })"
			>
				<div class="block-content text-end">
					<div class="fs-2 fw-bold">{{ card[0].total }}</div>
					<div class="fs-sm fw-semibold text-uppercase text-muted">Diamond</div>
					<div class="fs-sm fw-semibold text-uppercase text-muted">
						Total Entries
					</div>
				</div>
				<div
					class="block-content block-content-full d-flex justify-content-between align-items-center text-center"
				>
					<div class="fs-xs text-muted text-uppercase">
						<h6 class="mb-0 fw-semibold">{{ card[0].new }}</h6>
						<span>New</span>
					</div>
					<div class="fs-xs text-muted text-uppercase">
						<h6 class="mb-0 fw-semibold">{{ card[0].upgrade }}</h6>
						<span>Upgrade</span>
					</div>
					<div class="fs-xs text-muted text-uppercase">
						<h6 class="mb-0 fw-semibold">{{ card[0].renew }}</h6>
						<span>Renewals</span>
					</div>
				</div>
			</inertia-link>
		</div>
		<div class="col-md-6 col-xl-3">
			<inertia-link
				class="block block-rounded block-link-shadow"
				:href="route('admin.monitoring.index', { tab: 'Platinum' })"
			>
				<div class="block-content text-end">
					<div class="fs-2 fw-bold">{{ card[0].total }}</div>
					<div class="fs-sm fw-semibold text-uppercase text-muted">
						Platinum
					</div>
					<div class="fs-sm fw-semibold text-uppercase text-muted">
						Total Entries
					</div>
				</div>
				<div
					class="block-content block-content-full d-flex justify-content-between align-items-center text-center"
				>
					<div class="fs-xs text-muted text-uppercase">
						<h6 class="mb-0 fw-semibold">{{ card[0].new }}</h6>
						<span>New</span>
					</div>
					<div class="fs-xs text-muted text-uppercase">
						<h6 class="mb-0 fw-semibold">{{ card[0].upgrade }}</h6>
						<span>Upgrade</span>
					</div>
					<div class="fs-xs text-muted text-uppercase">
						<h6 class="mb-0 fw-semibold">{{ card[0].renew }}</h6>
						<span>Renewal</span>
					</div>
				</div>
			</inertia-link>
		</div>
	</div>
	<div v-if="card.length<=0" class="row">
		<div class="col-lg-12">
			<div class="block block-rounded block-link-shadow">
				<div class="block-content">
					<p class="p-5 text-bold text-danger text-center">No Record Found</p>	
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	props: {
		card: Object,
	}
}
</script>
